import React from "react";

import Label from "./Label";

import styles from "./Field.module.scss";

const SelectQueryField = React.forwardRef(
  (
    {
      errors,
      id,
      isRequired,
      label,
      defaultValue,
      description,
      placeholder,
      type,
      onChange,
      choices,
      choiceKey, // this is supposed to be choiceValue
      choiceValue, // this is supposed to be choiceLabel
      choiceHint,
      hint,
    },
    ref
  ) => {
    const isInvalid = errors[id] ? "is-invalid" : "";

    const options = choices.map((choice, index) => (
      <option key={index} value={choice[choiceKey]}>
        {choice[choiceValue]}
      </option>
    ));

    const hintedChoice = hint ? choices.find((choice) => choice[choiceHint] === hint) : null;
    const hintedKey = hintedChoice ? hintedChoice[choiceKey] : null;

    return (
      <div className={styles.formGroup} key={defaultValue}>
        <Label id={id} label={label} isRequired={isRequired} />
        <span className={`d-block ${styles.description}`}>{description}</span>
        <div className="row no-gutters">
          <div className="col">
            <select
              className={`${styles.field} ${styles.select} form-control ${isInvalid}`}
              required
              name={id}
              ref={ref}
              defaultValue={defaultValue || hintedKey || ""}
              onChange={onChange}
              disabled={choices.length === 0}
            >
              <option value="" disabled>
                {placeholder}
              </option>
              {options}
            </select>
            {errors[id] && <div className="invalid-feedback">This field is required.</div>}
          </div>
        </div>
      </div>
    );
  }
);

export default SelectQueryField;
